import { GetterTree } from 'vuex';

import { RootState, ListStatus } from '@/store/types';
import { createEditableGetters } from '@/store/utils/editable';

import { ConsultationRequestsState } from './types';

const {
  isLoading: editableIsLoading,
  isLoaded: editableIsLoaded,
  isSaving: editableIsSaving,
  isSaved: editableIsSaved,
  isFailed: editableIsFailed,
  isFetching: editableIsFetching,
  hasUnsavedChanges: editableHasUnsavedChanges,
} = createEditableGetters<ConsultationRequestsState>('editableStatus', 'editable', 'initialEditable');

export const moduleGetters: GetterTree<ConsultationRequestsState, RootState> = {
  /**
   * List
   */
  listIsLoading: (state) => state.listStatus === ListStatus.Loading,
  listIsLoaded: (state) => state.listStatus === ListStatus.Loaded,
  listIsError: (state) => state.listStatus === ListStatus.Failed,
  listIsEmpty: (state, getters) => getters.listIsLoaded && !state.list.length,
  lessQualifiedListIsLoading: (state) => state.lessQualifiedListStatus === ListStatus.Loading,
  lessQualifiedListIsLoaded: (state) => state.lessQualifiedListStatus === ListStatus.Loaded,
  lessQualifiedListIsError: (state) => state.lessQualifiedListStatus === ListStatus.Failed,
  lessQualifiedListIsEmpty: (state, getters) => getters.lessQualifiedListIsLoaded && !state.lessQualifiedList.length,

  /**
   * Edit
   */
  editableIsLoading,
  editableIsLoaded,
  editableIsSaving,
  editableIsSaved,
  editableIsFailed,
  editableHasUnsavedChanges,
  editableIsFetching,

  /**
   * User stats
   */
  userStatsIsLoading: (state) => state.userStatsStatus === ListStatus.Loading,
  userStatsIsLoaded: (state) => state.userStatsStatus === ListStatus.Loaded,
  userStatsIsFailed: (state) => state.userStatsStatus === ListStatus.Failed,
};

export default moduleGetters;
